/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams, AuditReportsGetOlafReprocessJobStatusByOrderId401, AuditReportsGetOlafReprocessJobStatusByOrderId403, AuditReportsGetOlafReprocessJobStatusByOrderId404 } from "../models/AuditReportsGetOlafReprocessJobStatusByOrderId";

export function getAuditReportsGetOlafReprocessJobStatusByOrderIdUrl(orderId: AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams["orderId"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/olaf/reprocess/job-status-by-order/${orderId}` as const }
  return res
}

/**
 * @description Finds and returns the most recent reprocess job for the given order ID(s) within the user's client. The provided orders must exactly match the orders in the job.
 * @summary Get OLAF reprocess job status by order ID
 * {@link /audit-reports/v1/olaf/reprocess/job-status-by-order/:orderId}
 */
export async function auditReportsGetOlafReprocessJobStatusByOrderId(orderId: AuditReportsGetOlafReprocessJobStatusByOrderIdPathParams["orderId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetOlafReprocessJobStatusByOrderIdQueryResponse, ResponseErrorConfig<AuditReportsGetOlafReprocessJobStatusByOrderId401 | AuditReportsGetOlafReprocessJobStatusByOrderId403 | AuditReportsGetOlafReprocessJobStatusByOrderId404>, unknown>({ method : "GET", url : getAuditReportsGetOlafReprocessJobStatusByOrderIdUrl(orderId).url.toString(), ... requestConfig })
  return res.data
}